/* @generated */
import * as React from "react";
import { contentIconRecipe } from "../styles/index.css.esm.js";
import classNames from "classnames";
import { useThemedStyle } from "../hooks/useThemedStyle.esm.js";
import { BackgroundFileLarge } from "./_background/background-file-large.esm.js";
import { useCompositeContentIconViewBox } from "../hooks/useContentIconViewbox.esm.js";
const FilePremiereLarge = ({
  className,
  hasWhitespace = true,
  over = "base",
  hasBackground = true,
  ...props
}) => {
  const cls = classNames([
    "dig-ContentIcon",
    className,
    "dig-ContentIcon--large",
    {
      "dig-ContentIcon--overBase": over === "base",
      "dig-ContentIcon--overSubtle": over === "subtle",
      "dig-ContentIcon--hasNoBackground": !hasBackground
    },
    contentIconRecipe({ over, hasNoBackground: !hasBackground })
  ]);
  const style = useThemedStyle({ over });
  const viewBox = useCompositeContentIconViewBox({ hasWhitespace, size: "large" });
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      viewBox,
      fill: "none",
      role: "presentation",
      focusable: "false",
      width: 160,
      height: 160,
      className: cls,
      "data-testid": "FilePremiereLarge",
      style,
      ...props
    },
    hasBackground ? /* @__PURE__ */ React.createElement(BackgroundFileLarge, null) : null,
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M32.576 40.712c4.512.024 6.672-2.304 6.672-5.904 0-3.432-2.208-5.808-6.792-5.808H26v17.112h3.096v-5.4h3.48Zm-.12-9.024c2.448 0 3.648 1.272 3.648 3.12 0 2.088-1.296 3.216-3.576 3.216h-3.432v-6.336h3.36Zm12.152 14.424v-6.384c0-3.192.768-4.344 4.008-4.344h1.368v-3.192h-.936c-2.592 0-4.056 1.104-4.584 3.36l-.408-3.24h-2.544v13.8h3.096Z",
        fill: "#9B49F2"
      }
    )
  );
};
export {
  FilePremiereLarge
};
